import useSWRImmutable from 'swr/immutable';

import { getUserMappings } from '@/api/dcprofessional/DcProfessionalCalls.js';

import { useProfessionalsStore } from '@/zustandStore.js';

const useProfessionalMappings = () => {
    const fetcher = async () => {
        const response = await getUserMappings();
        if (!response.data?.data) return;

        const professionalMappingsObj = {};
        const lightMappingsObj = {};

        for (const mapping of response.data.data) {
            if (!mapping.prismic_key) continue;

            professionalMappingsObj[mapping.prismic_key] = mapping;

            if (!mapping.dc_user_id || mapping.dc_user_id === '-') {
                lightMappingsObj[mapping.prismic_key] = mapping;
            }
        }

        useProfessionalsStore.setState({
            professionalMappings: professionalMappingsObj,
            lightMappings: lightMappingsObj,
        });
    };

    useSWRImmutable('professional-mappings', fetcher);
};

export default useProfessionalMappings;
